import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EntityService } from './entity.service';
import { BidiConfiguration } from '@models/bidiConfiguration';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BidiConfigurationDto } from '@dto/bidiConfigurationDto';

@Injectable({
  providedIn: 'root'
})
export class BidiConfigurationService extends EntityService {
  public entityRoute: any;

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);

  }


  get(bidiConfigId: string): Observable<BidiConfiguration> {
    return this.http.get<BidiConfiguration>(`${this.baseUrl}api/BidiConfiguration/${bidiConfigId}`)
      .pipe(map(data => new BidiConfiguration(data))
      );
  }

  getBidiConfigurationDtoByGatewayId(gatewayId: number): Observable<BidiConfigurationDto> {
    return this.http.get<BidiConfigurationDto>(`${this.baseUrl}api/BidiConfiguration/getBidiConfigurationDtoByGatewayId/${gatewayId}`)
      .pipe(map(data => new BidiConfigurationDto(data))
      );
  }

  createUpdateBidiConfiguration(bidiConfigDto: BidiConfigurationDto): Observable<BidiConfigurationDto> {
    return this.http.post<BidiConfigurationDto>(`${this.baseUrl}api/BidiConfiguration/createUpdateBidiConfiguration`, bidiConfigDto)
      .pipe(map(data => new BidiConfigurationDto(data))
      );
  }







}